<template>
  <v-container class="component_main py-1 px-6">
    <v-row v-show="showList">
      <v-col class="pb-0 mt-0" cols="12" sm="6" md="8">
        <h1>Agenda de Cronogramas
          <span>
              <v-tooltip right >
                <template v-slot:activator="{on, attrs}">
                  <v-btn
                  class="" 
                  color="primary" 
                  icon
                  small
                  @click=modalVideo()
                  v-bind="attrs"
                  v-on="on"  
                  >
                <v-icon small>fa-regular fa-life-ring</v-icon>
              </v-btn>
                </template>
                <span class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    ">Ajuda: Como criar o cronograma </span>
              </v-tooltip>
            </span>
        </h1>
        <p>
          Crie e gerencie as entregas do seu faturamento
        </p>
      </v-col>
      <v-col class="pb-0 text-right pt-7" cols="12" sm="6" md="4">
        <v-btn 
          v-if="userData.PermissaoAcoes.faturamento.includes('addcronograma')"
          color="primary" 
          height="30px"
          small
          depressed 
          to="/faturamento/agendacronogramas/novocronograma"
        >Novo Cronograma</v-btn>
        <v-tooltip v-else center bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            outlined
            color="rgb(151 151 151 / 58%)"
            height="30px"
            small
            depressed
            v-bind="attrs"
            v-on="on"
            >Novo Cronograma</v-btn>
          </template>
          <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
            Você não possui permissão para executar esta ação.
          </span>
        </v-tooltip>
      </v-col>
    </v-row>
    <Agendafilter
      v-show="showList"
      :operadoras="operadoras"
      :prestadores="prestadores"
      :responsaveis="responsaveis"
      :getList="(filterData)=> getAgenda(filterData)"
    />
    <Agendacalendar 
      v-show="showList" 
      :events="filteredList" 
      :eventclick="(event)=>getCronogramaListByAgenda(event)" 
      :feriadosList="feriadosList"
      :newFeriadosList="(year)=> prestador_id? getFeriados(year) : true"
      :referenceYear="referenceYear"
      :permissoes="userData.PermissaoAcoes"
    />
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex"
import Agendacalendar from "@/components/faturamento/agenda/AgendaCalendar"
import Agendafilter from "@/components/faturamento/agenda/AgendaFilter"
export default {
  components: {
    Agendacalendar,
    Agendafilter
  },
  data() {
    return {
      controlResponsavel: false,
      filteredList: [],
      operadoras: [],
      prestadores: [],
      responsaveis: [],
      showList: true,
      gerenciarFeriado: false,
      year: null,
      prestador_id: null,
      dt_cores: null,
      ind_cores: 0
    };
  },
  mounted() {
    this.controlResponsavel = !this.userData.Permissao.faturamento.includes('gestor')
    let opts = {
      grupoEconomico: this.grupoEconomico,
      modulo_operadora: "faturamento",
      limitar: false,
    };
    this.getAgenda(opts);
    this.getOperadoras(opts);
    this.getResponsaveis(opts);
    this.prestadores = this.$store.getters[
      "permissions/getPrestadoresByGeco"
    ]();
  },
  watch: {
    grupoEconomico: {
      deep: true,
      handler() {
        let opts = {
          grupoEconomico: this.$store.state.permissions.grupoEconomico,
          modulo_operadora: "faturamento",
          limitar: false,
        };
        this.getAgenda(opts);
        this.getOperadoras(opts);
        this.getResponsaveis(opts);
      },
    },
    grupoEconomicoList: {
      deep: true,
      handler() {
        this.prestadores = this.$store.getters[
          "permissions/getPrestadoresByGeco"
        ]();
      },
    },
    listAgenda(val) {
      this.ind_cores = 0
      this.filteredList = val.map(this.filterList)
    },
    listOperadora(val) {
      this.operadoras = val;
    },
    listResponsavel(val) {
      this.responsaveis = val;
    },
  },
  computed: {
    ...mapState({
      // filter: (state) => state.faturamento.filter,
      filterAgenda: (state) => state.faturamento.filterAgenda,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
      feriadosList: (state) => state.common.feriadosList,
      listAgenda: (state) => state.faturamento.listAgenda,
      listOperadora: (state) => state.faturamento.listOperadora,
      listResponsavel: (state) => state.faturamento.listResponsavel,
      referenceYear: (state) => state.common.referenceYear,
      userData: (state) => state.userData.userData,
    }),
  },
  methods: {
    ...mapActions({
      "getAgenda":"faturamento/getAgenda",
      "getResponsaveis":"faturamento/getResponsaveis",
      "getOperadoras": "permissions/getOperadoras",
      "getFeriados": "common/getFeriados"
    }),
    modalVideo(){
      let paramModal = {
          codigo: "752630275",
          title: "Como criar o cronograma",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },
    addCronograma(){
      this.showList = false
    },
    filterList(el){
      if(this.dt_cores == el.dt_faturamento){
        this.ind_cores++
        } else {
          this.ind_cores = 0
          this.dt_cores = el.dt_faturamento
        }
        let hora = (this.ind_cores > 60)? (this.ind_cores/60).toInt() : '00'
        let minuto
        if(this.ind_cores > 60){
          minuto = this.ind_cores%60 > 9? this.ind_cores%60 : '0'+this.ind_cores%60
        } else {
          minuto = this.ind_cores > 9? this.ind_cores : '0'+this.ind_cores
        }
          el.start = el.dt_faturamento+"T"+ hora +":"+minuto
          el.end = el.dt_faturamento+"T"+ hora +":"+minuto
          // el.color= (this.ind_cores%2)? "#118ACA" : "#06679A"
          el.color= "#06679A"
          el.timed = false
          return el
    },
    getCronogramaListByAgenda({day, event}) {
      let filter = {
        prestador: event.prestador_id,
        operadora_ans_id: event.operadora_ans_id,
        owner_id: null,
        dt_faturamento_ini: day.date,
        dt_faturamento_fim: day.date
      }
      this.$store.commit("faturamento/setFilter", filter, {root:true})
      this.$router.push('/faturamento/cronogramas')
    },
    saveItem(formData) {
      formData.grupo_economico = this.grupoEconomico

      let acao = "addcronograma"
      let payload = formData

      var data = {
        query: 
        [{
          "Modulo": "faturamento",
          "Acao": acao,
          "Payload": payload
        }]
      };

      this.$store.dispatch("request/doRequest", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getAgenda({grupo_economico:this.grupoEconomico}).then(()=>this.showList = true)
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    close(val) {
      this.gerenciarFeriado = val
    },
  },
};
</script>